import React, { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import { CALENDAR_SALE, EXERCISE_SCHEDULE } from "../../../routes";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFacility from "../../../../utils/hooks/useFacility";

interface IProps {
  ticket: Ticket;
}
const SelectPassModalFooter: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [bookingOnSchedule, setBookingOnSchedule] = useState<boolean>(true);
  const facilityIds = useFacility();

  useEffect(() => {
    if(facilityIds === '1212' && ticket.objectId === 112847){
      setBookingOnSchedule(false)
    }
  }, [facilityIds]);

  return (
    <React.Fragment>
      <div className="select-pass-modal-footer ">
        <div className="alert alert-action flex-start-center">
          <div className="flex-start-center">
            <span>{t("pozostalo_ci_do_wykorzystania")}</span>

            {ticket.entrances - ticket.exercises.length > 500 ? (
              <b>bez limtu   </b>
           
            ) : (

              <b>{ticket.entrances - ticket.exercises.length}</b>
            )}


            <span> {t("zapisow")}. </span>
          </div>

              {bookingOnSchedule ? (      <Link className="button text small padding-zero button-text-gray" to={EXERCISE_SCHEDULE}>
            {t("przejdz_do_harmonogramu_aby_sie_zapisac")}
          </Link>) : (      <Link className="button text small padding-zero button-text-gray" to={CALENDAR_SALE}>
            {t("przejdz_do_kalendarza_aby_sie_zapisac")}
          </Link>)}
    

          
        </div>
      </div>
    </React.Fragment>
  );
};

export default SelectPassModalFooter;
